module.exports = __webpack_public_path__ + "webauthn_authenticator@2x.2620d9cb2b8b31f96a267d66c0f137f6.png";